import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class Row {
    constructor() {
    }
}

export function Row$reflection() {
    return class_type("Feliz.TanStack.Table.Row.Row", void 0, Row);
}

export function Row_getValue(column, row) {
    return row.getValue(column.id);
}

export function Row_getCanExpand_773C3262(row) {
    return row.getCanExpand();
}

export function Row_getIsExpanded_773C3262(row) {
    return row.getIsExpanded();
}

//# sourceMappingURL=Row.fs.js.map
